import {
  FIELD_TYPE_INPUT_COMPONENT,
  FIELD_TYPE_OPERATORS,
  FieldTypeEnum,
  InputComponentType,
  OPERATOR_LABELS,
  OperatorOption,
} from "@via/components/advanced-filter/helpers/types";

// Helper function to get operators for a field type
export function getOperatorsForFieldType(
  fieldType: FieldTypeEnum
): OperatorOption[] {
  const operators = FIELD_TYPE_OPERATORS[fieldType] || [];
  return operators.map(operator => ({
    value: operator,
    label: OPERATOR_LABELS[operator],
  }));
}

// Helper function to get input component type for a field type
export function getInputComponentTypeForFieldType(
  fieldType: FieldTypeEnum
): InputComponentType {
  return FIELD_TYPE_INPUT_COMPONENT[fieldType] || InputComponentType.Text;
}

// Helper function to determine field type from string
export function getFieldTypeFromString(typeString: string): FieldTypeEnum {
  switch (typeString?.toLowerCase()) {
    case "string":
    case "mongoose.schema.types.string":
      return FieldTypeEnum.String;
    case "number":
    case "mongoose.schema.types.number":
      return FieldTypeEnum.Number;
    case "boolean":
    case "mongoose.schema.types.boolean":
      return FieldTypeEnum.Boolean;
    case "date":
    case "mongoose.schema.types.date":
      return FieldTypeEnum.Date;
    case "array":
    case "mongoose.schema.types.array":
      return FieldTypeEnum.Array;
    case "mixed":
    case "mongoose.schema.types.mixed":
      return FieldTypeEnum.Mixed;
    default:
      return FieldTypeEnum.String; // Default fallback
  }
}
